import React from "react";
import { useNavigate } from "react-router-dom";

export const AdventurePath = () => {
  const navigate = useNavigate();

  const handleNavigation = (path) => {
    navigate(path);
  };

  return (
    <div className="bg-white rounded-3xl p-6 w-full mx-auto shadow-md md:shadow-lg">
      <div className="flex items-start mb-5">
        <div className="min-w-10 h-10 bg-indigo-500 rounded-full flex items-center justify-center mr-4 text-white text-xl flex-shrink-0">
          <span className="material-icon">🌟</span>
        </div>
        <div className="flex-grow">
          <h2 className="m-0 text-lg font-semibold text-gray-800">
            Choose Your Adventure Path
          </h2>
          <p className="mt-1 text-sm text-gray-600">
            How would you like to show your current skills?
          </p>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-3 mb-8">
        <button
          className="p-3 rounded-lg border-none text-sm font-medium cursor-pointer text-center transition-all duration-200 ease-in-out whitespace-nowrap overflow-hidden text-ellipsis bg-indigo-500 text-white hover:opacity-90 hover:-translate-y-px active:translate-y-px"
          onClick={() => handleNavigation("/assessment")}
        >
          Self Assessment
        </button>
        <button
          className="p-3 rounded-lg border-none text-sm font-medium cursor-pointer text-center transition-all duration-200 ease-in-out whitespace-nowrap overflow-hidden text-ellipsis bg-white text-gray-700 shadow hover:opacity-90 hover:-translate-y-px active:translate-y-px disabled:opacity-50 disabled:cursor-not-allowed"
          onClick={() => handleNavigation("/practice/evaluateAnswerSheet")}
          //disabled
        >
          Evaluate Answer Sheets
        </button>
        <button
          className="p-3 rounded-lg border-none text-sm font-medium cursor-pointer text-center transition-all duration-200 ease-in-out whitespace-nowrap overflow-hidden text-ellipsis bg-white text-gray-700 shadow hover:opacity-90 hover:-translate-y-px active:translate-y-px disabled:opacity-50 disabled:cursor-not-allowed"
          onClick={() => handleNavigation("/practice")}
          //disabled
        >
          Take Aanya Challenge
        </button>
      </div>
    </div>
  );
};

export default AdventurePath;
